import type React from 'react';
import { SidebarLayout } from '@/layouts/sidebar.layout';

/**
 * Main column for pages with a fixed side rail.
 *
 * SidebarLayout disables scrolling on `main` when a side rail is present.
 * This wrapper restores page-level scroll inside the main column so sticky
 * headers (e.g. CenteredContent Header) share a scroll container with content.
 * Pass `overlay` for viewport-pinned UI (e.g. a floating chat bar).
 */
export function SideRailLayout({
  children,
  sideRail,
  overlay,
  className,
}: {
  children: React.ReactNode;
  sideRail: React.ReactNode;
  overlay?: React.ReactNode;
  className?: string;
}) {
  return (
    <SidebarLayout className={className} sideRail={sideRail}>
      <div className="relative h-full min-h-0">
        <div className="h-full min-h-0 overflow-y-auto">{children}</div>
        {overlay}
      </div>
    </SidebarLayout>
  );
}
